import React from 'react';

export const reviewLanguageContent = {
    'review': {
        'en': 'Review',
        'ar': 'مراجعة',
        'ht': 'Revizyon',
        'pl': 'Recenzja',
        'pt': 'Análise',
        'sr': 'Преглед',
        'es': 'Revisar',
        'vi': 'Ôn tập',
        'zh': '审查',
        'ne': 'समीक्षा गर्नुहोस्'
    },
    'review-content': {
        'en':  <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>Thank you.</b> Completed forms and other materials 
            will be Emailed to you shortly. Press <b className='font-semibold'>Done</b> to logout of the system. Please note, once you logout you will not be able to further access this visits information once you do so.</p>,
        'ar': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>شكرًا لك.</b> النماذج المكتملة والمواد الأخرى
            سيتم إرسالها إليك عبر البريد الإلكتروني قريبًا. اضغط على <b className='font-semibold'>تم</b> لتسجيل الخروج من النظام. يرجى ملاحظة أنه بمجرد تسجيل الخروج، لن تتمكن من الوصول إلى معلومات الزيارات هذه بمجرد القيام بذلك.</p>,
        'ht': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>Mèsi.</b> Fòm ak lòt materyèl ranpli
            yo pral voye imèl ba ou yon ti tan. Peze <b className='font-semibold'>Fè</b> pou dekonekte sistèm lan. Tanpri sonje, yon fwa w fin dekonekte w, ou p ap kapab jwenn plis aksè a enfòmasyon sou vizit sa yo yon fwa w fè sa.</p>,
        'pl': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>Dziękujemy.</b> Wypełnione formularze i inne materiały
            zostanie wkrótce przesłany do Ciebie e-mailem. Naciśnij <b className='font-semibold'>Gotowe</b>, aby wylogować się z systemu. Pamiętaj, że po wylogowaniu nie będziesz mieć dalszego dostępu do informacji o wizytach.</p>,
        'pt': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>Obrigado.</b> Formulários preenchidos e outros materiais
            será enviado para você em breve. Pressione <b className='font-semibold'>Concluído</b> para sair do sistema. Observe que, depois de sair, você não poderá mais acessar essas informações de visitas.</p>,
        'sr': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>Хвала.</b> Попуњени обрасци и други материјали
            биће вам ускоро послато е-поштом. Притисните <b className='font-semibold'>Готово</b> да бисте се одјавили са система. Имајте на уму да када се одјавите, нећете моћи даље да приступате овим информацијама о посетама када то учините.</p>,
        'es': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>Gracias.</b> Formularios completados y otros materiales
            se le enviará por correo electrónico en breve. Presione <b className='font-semibold'>Listo</b> para cerrar sesión en el sistema. Tenga en cuenta que una vez que cierre la sesión, no podrá acceder a la información de esta visita una vez que lo haga.</p>,
        'vi': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>Cảm ơn bạn.</b> Các biểu mẫu đã hoàn thành và các tài liệu khác
            sẽ sớm được gửi qua email cho bạn. Nhấn <b className='font-semibold'>Xong</b> để đăng xuất khỏi hệ thống. Xin lưu ý, sau khi đăng xuất, bạn sẽ không thể truy cập thêm thông tin lượt truy cập này sau khi đăng xuất.</p>,
        'zh': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>谢谢。</b>已填妥的表格和其他材料
            很快就会通过电子邮件发送给您。按<b className='font-semibold'>完成</b>退出系统。请注意，一旦您注销，您将无法进一步访问此访问信息。</p>,
        'ne': <p className='mt-[18px] text-justify text-primary font-normal text-sm'>
            <b className='text-[#333] font-semibold'>धन्यवाद।</b> फारम र अन्य सामग्रीहरू पूरा गरियो
            तपाईंलाई छिट्टै इमेल गरिनेछ। प्रणाली लगआउट गर्न <b className='font-semibold'>सम्पन्न</b> थिच्नुहोस्। कृपया ध्यान दिनुहोस्, एक पटक लगआउट गरेपछि तपाईले यस भ्रमण जानकारीलाई थप पहुँच गर्न सक्षम हुनुहुने छैन।</p>
    },
    'id-insurance': {
        'en': 'ID & Insurance',
        'ar': 'الهوية والتأمين',
        'ht': 'ID & Asirans',
        'pl': 'Dowód osobisty i ubezpieczenie',
        'pt': 'Identificação e Seguro',
        'sr': 'ИД и осигурање',
        'es': 'Identificación y seguro',
        'vi': 'ID & Bảo hiểm',
        'zh': '身份证件和保险',
        'ne': 'आईडी र बीमा'
    },
    'edit': {
        'en': 'Edit',
        'ar': 'يحرر',
        'ht': 'Edit',
        'pl': 'Edytować',
        'pt': 'Editar',
        'sr': 'Уредити',
        'es': 'Editar',
        'vi': 'Biên tập',
        'zh': '编辑',
        'ne': 'सम्पादन गर्नुहोस्'
    },
    'not-provided': {
        'en': 'Not Provided',
        'ar': 'غير مزود',
        'ht': 'Pa bay',
        'pl': 'Niedostarczone',
        'pt': 'Não fornecido',
        'sr': 'Није обезбеђено',
        'es': 'No provisto',
        'vi': 'Không cung cấp',
        'zh': '不提供',
        'ne': 'प्रदान गरिएको छैन'
    },
    'ID': {
        'en': 'ID',
        'ar': 'بطاقة تعريف',
        'ht': 'ID',
        'pl': 'ID',
        'pt': 'EU IA',
        'sr': 'ИД',
        'es': 'IDENTIFICACIÓN',
        'vi': 'NHẬN DẠNG',
        'zh': 'ID',
        'ne': 'ID'
    },
    'insurance': {
        'en': 'Insurance',
        'ar': 'تأمين',
        'ht': 'Asirans',
        'pl': 'Ubezpieczenie',
        'pt': 'Seguro',
        'sr': 'Осигурање',
        'es': 'Seguro',
        'vi': 'Bảo hiểm',
        'zh': '保险',
        'ne': 'बीमा'
    },
    'policy': {
        'en': 'Policy',
        'ar': 'سياسة',
        'ht': 'Règleman',
        'pl': 'Polityka',
        'pt': 'Político',
        'sr': 'Полици',
        'es': 'Política',
        'vi': 'Chính sách',
        'zh': '政策',
        'ne': 'नीति'
    },
    'holder': {
        'en': 'Holder',
        'ar': 'مالك',
        'ht': 'Holder',
        'pl': 'Uchwyt',
        'pt': 'Suporte',
        'sr': 'Холдер',
        'es': 'Poseedor',
        'vi': 'Người giữ',
        'zh': '持有者',
        'ne': 'होल्डर'
    },
    'view': {
        'en': 'View',
        'ar': 'منظر',
        'ht': 'View',
        'pl': 'Pogląd',
        'pt': 'Visualizar',
        'sr': 'Поглед',
        'es': 'Vista',
        'vi': 'Xem',
        'zh': '看法',
        'ne': 'हेर्नुहोस्'
    },
    'hide': {
        'en': 'Hide',
        'ar': 'يخفي',
        'ht': 'Kache',
        'pl': 'Ukrywać',
        'pt': 'Esconder',
        'sr': 'Сакрити',
        'es': 'Esconder',
        'vi': 'Trốn',
        'zh': '隐藏',
        'ne': 'लुकाउनुहोस्'
    },
}